export const STATUS_META = {
  draft: { label: 'Draft', color: '#9e9e9e' },
  submitted: { label: 'With cluster manager', color: '#ff9800' },
  cluster_approved: { label: 'With At Apartment head', color: '#ff5722' },
  final_approved: { label: 'Awaiting HQ review', color: '#2196f3' },
  in_daily: { label: 'On daily sheet', color: '#3f51b5' },
  handed_over: { label: 'Handed over — confirm receipt', color: '#9c27b0' },
  closed: { label: 'Closed', color: '#4caf50' },
  rejected: { label: 'Rejected', color: '#f44336' }
}

// Labels mirror the Status tracking stages so the Dispatch chip/dropdown and
// the timeline read the same (2026-07-25, P2). Enum values unchanged.
export const FULFILMENT_META = {
  pending: { label: 'Pending', color: '#9e9e9e' },
  ordered: { label: 'Sent to vendor', color: '#ff9800' },
  dispatched: { label: 'Received by HQ procurement team', color: '#2196f3' },
  delivered: { label: 'Delivered / done', color: '#4caf50' },
  unavailable: { label: 'Unavailable', color: '#f44336' }
}

export const RECEIPT_META = {
  pending: { label: 'Pending', color: '#9e9e9e' },
  received: { label: 'Received', color: '#4caf50' },
  not_received: { label: 'Not received', color: '#f44336' },
  discrepancy: { label: 'Discrepancy', color: '#ff9800' }
}

export const money = (v) =>
  `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`

// What went wrong, in the words the API used. Every grid save runs through
// this — a refused save used to fail silently and read to the team as "the
// button does nothing" (2026-07-22).
//
// oh-api does NOT answer in DRF's own shapes. `rest_exception_handler` rewraps
// everything as {error: true, success: false, message: "...", messages: ...},
// so `message` is the only field worth reading. Reading "the first key" landed
// on `error` and printed "could not add the line — true", which is how this was
// caught. DRF's own {detail} / [".."] / {field: [".."]} are still handled for
// anything that slips past the handler.
export const apiErrorText = (e) => {
  const data = e && e.response && e.response.data
  if (typeof data === 'string' && data.trim()) return data
  if (Array.isArray(data) && data.length) return String(data[0])
  if (data && typeof data === 'object') {
    if (data.message) return String(data.message)
    if (data.detail) return String(data.detail)
    // The handler sets `messages` to the string "No Messages" when the
    // exception carried none — only use it when it is a real list.
    if (Array.isArray(data.messages) && data.messages.length) {
      return data.messages.join('; ')
    }
    // A bare DRF field-error map: skip the envelope's own booleans.
    const skip = new Set(['error', 'success', 'message_dict', 'messages',
      'error_code', 'show_error_msg', 'error_type'])
    const first = Object.keys(data).find(
      (k) => !skip.has(k) && typeof data[k] !== 'boolean'
    )
    if (first) {
      const v = data[first]
      return String(Array.isArray(v) ? v[0] : v)
    }
  }
  return (e && e.message) || 'Something went wrong.'
}
